/**
 * @generated SignedSource<<80ecbea8e8e5d32e249b5dfb3c587a7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddBundleAction = "add" | "delete" | "keep" | "modify";
export type AddBundleAutoRenew = "GR" | "OFF" | "ON";
export type AddBundleSystemAction = "ADDED" | "CANCEL" | "NONE" | "RESUME" | "TERMINATE" | "UPDATE";
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type ProcessContext = "ADD_VAS" | "BUY_ONE_NUMBER" | "CHANGE_OFFER" | "MANAGE_VAS" | "MOBILE_MIGRATE" | "MODIFY_OFFER" | "NEW_OFFER" | "NONE";
export type AddBundlesInput = {
  agentDetails?: AgentDetailsRequest | null;
  bundles: ReadonlyArray<AddBundlesInputBundle>;
  cartId?: string | null;
  channel: CartChannel;
  processContext?: ProcessContext | null;
};
export type AgentDetailsRequest = {
  channelName: string;
  dealerCode: string;
  salesAgentId: string;
};
export type AddBundlesInputBundle = {
  accountNumber?: string | null;
  categoryId?: string | null;
  items: ReadonlyArray<AddBundlesInputItem>;
  lineNumber?: string | null;
};
export type AddBundlesInputItem = {
  action?: AddBundleAction | null;
  agentDetails?: AgentDetailsRequest | null;
  associatedProductOfferingId?: string | null;
  offerId: string;
  productCharacteristics?: ProductCharacteristicsInput | null;
  productInstanceId?: string | null;
  quantity?: number | null;
};
export type ProductCharacteristicsInput = {
  autoRenew?: AddBundleAutoRenew | null;
  systemAction?: AddBundleSystemAction | null;
};
export type useAddBundlesMutation$variables = {
  input: AddBundlesInput;
};
export type useAddBundlesMutation$data = {
  readonly addBundles: {
    readonly bundles: ReadonlyArray<{
      readonly bundleId: string;
      readonly isAffected: boolean;
      readonly items: ReadonlyArray<{
        readonly itemId: string;
      }>;
    }> | null;
    readonly code: number;
    readonly message: string;
    readonly success: boolean;
  };
};
export type useAddBundlesMutation = {
  response: useAddBundlesMutation$data;
  variables: useAddBundlesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddBundleOperationResponse",
    "kind": "LinkedField",
    "name": "addBundles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AddBundlesResponse",
        "kind": "LinkedField",
        "name": "bundles",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bundleId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddBundlesResponseItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "itemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAffected",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddBundlesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAddBundlesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "586c6a0053aebe2ed951b0aa1cafb764",
    "id": null,
    "metadata": {},
    "name": "useAddBundlesMutation",
    "operationKind": "mutation",
    "text": "mutation useAddBundlesMutation(\n  $input: AddBundlesInput!\n) {\n  addBundles(input: $input) {\n    code\n    message\n    success\n    bundles {\n      bundleId\n      items {\n        itemId\n      }\n      isAffected\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4de540c8d4cd07aea8b53d9ab53400b8";

export default node;
